import {Component,OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import * as cartActions from "../../state/shopping-cart/cart-action";
import { Store } from '@ngrx/store';
@Component({
    selector: 'app-clear-cart',
    templateUrl: './clear-cart.component.html',
    styleUrls: ['./clear-cart.component.scss'],
})
export class ClearCartComponent implements OnInit, OnDestroy {
    constructor(private store: Store<any>, public modal: NgbActiveModal) {}
    ngOnInit(): void {}
    clear= ():void => {
      this.modal.close();
      return this.store.dispatch(cartActions.ClearCart());
    }
    ngOnDestroy(): void { }
}

